import React from 'react';
import NetworkHealthDashboard from '../public/NetworkHealthDashboard';
import DashboardPane from '../chat/DashboardPane';
import ChatPane from '../chat/ChatPane';
import GroupChatPane from '../chat/GroupChatPane';
import PublicChannelsPane from '../chat/PublicChannelsPane';
import ComposerPane from '../chat/ComposerPane';
import ReaderPane from '../chat/ReaderPane';
import ProfilePane from '../chat/ProfilePane';
import VaultPane from '../chat/VaultPane';
import DropPane from '../chat/DropPane';
import AbuseCenter from '../chat/AbuseCenter';
import SecurityCenter from '../chat/SecurityCenter';

export default function AppMainContent(props) {
  const {
    hasActiveContent,
    currentMenu,
    setMobileMenuOpen,
    t,
    mailListCollapsed,
    setMailListCollapsed,
    rooms,
    contacts,
    chatMessages,
    inboxEmails,
    activeIdentity,
    setCurrentMenu,
    setActiveChatContact,
    setActiveRoom,
    setShowCreateGroupModal,
    displayGaiaID,
    deferredPrompt,
    handleInstallApp,
    activeChatContact,
    presenceMap,
    chatInputText,
    setChatInputText,
    handleSendChatMessage,
    showEmojiPicker,
    setShowEmojiPicker,
    handleDeleteChatMessage,
    handleEditChatMessage,
    setInboxEmails,
    setSentEmails,
    handleClearDirectChat,
    openContactProfile,
    messageMeta,
    toggleMessagePin,
    toggleMessageSaved,
    reactToMessage,
    activeDirectUnreadMarker,
    messageReplyTarget,
    setMessageReplyTarget,
    getSenderRoles,
    activeRoom,
    channels,
    activeChannel,
    setActiveChannel,
    handleSendGroupMessage,
    chatUploadProgress,
    uploadChatFile,
    toggleBlockContact,
    handleUpdateMemberRole,
    handleLeaveRoom,
    setShowCreateChannelModal,
    triggerAlert,
    handleOpenGroupSettings,
    handleClearGroupChannel,
    activeGroupUnreadMarker,
    activePublicChannel,
    publicChannelCreatorOpen,
    setPublicChannelCreatorOpen,
    publicChannelPosts,
    publicChannelsError,
    publicChannelPostsLoading,
    createPublicChannel,
    updatePublicChannel,
    togglePublicChannelSubscription,
    createPublicChannelPost,
    togglePublicChannelPostReaction,
    createPublicChannelPostComment,
    togglePublicChannelPostPin,
    updatePublicChannelComments,
    reportChannel,
    deleteChannel,
    verifyChannel,
    showConfirm,
    isComposing,
    isSmtpMode,
    setIsSmtpMode,
    composeTo,
    setComposeTo,
    composeSubject,
    setComposeSubject,
    composeBody,
    setComposeBody,
    fileInputRef,
    handleFileUpload,
    uploadFile,
    uploadProgress,
    composeError,
    handleSendMail,
    setIsComposing,
    selectedMail,
    selectedMailProof,
    handleReplyMail,
    handleExportDisclosurePackage,
    handleReportMail,
    setSelectedMail,
    profileAvatar,
    setProfileAvatar,
    profileDisplayName,
    setProfileDisplayName,
    profileBio,
    setProfileBio,
    saveProfile,
    handleAvatarFileChange,
    currentPasswordInput,
    setCurrentPasswordInput,
    newPasswordInput,
    setNewPasswordInput,
    confirmPasswordInput,
    setConfirmPasswordInput,
    passwordChangeError,
    handleChangePassword,
    areKeysUnlocked,
    profilePasswordInput,
    setProfilePasswordInput,
    handleUnlockProfileKeys,
    profileUnlockError,
    derivedKeys,
    mnemonic,
    setAreKeysUnlocked,
    activeProfileSection,
    setActiveProfileSection,
    cryptoSessionMinutes,
    setCryptoSessionMinutes,
    inactivityLockMinutes,
    setInactivityLockMinutes,
    pinUnlockEnabled,
    handleSetUnlockPin,
    handleRemoveUnlockPin,
    handleDeleteAccount,
    handleExportRecoveryBackup,
    user,
    handleUpdatePrivacySettings,
    vaultUnlocked,
    vaultPasswordInput,
    setVaultPasswordInput,
    vaultError,
    vaultRecords,
    vaultDraftTitle,
    setVaultDraftTitle,
    vaultDraftCategory,
    setVaultDraftCategory,
    vaultDraftBody,
    setVaultDraftBody,
    handleUnlockVault,
    handleAddVaultRecord,
    handleDeleteVaultRecord,
    handleLockVault,
    selectedVaultRecord,
    setSelectedVaultRecord,
    gaiaDropInbox,
    gaiaDropLoading,
    gaiaDropError,
    selectedDrop,
    setSelectedDrop,
    loadGaiaDropInbox,
    handleDeleteDrop,
    labelsList,
    filterRules,
    mailSettings,
    isSavingDraft,
    saveFilterRule,
    saveSettings,
    fetchRooms,
    updateMailboxState,
    snoozeMail,
    saveLabel
  } = props;

  return (
    <>
      {/* COLUMN 3: READER / COMPOSER / PROFILE / CHAT PANE */}
      <main className="mail-content-pane" style={{ position: 'relative' }}>
        {hasActiveContent && currentMenu !== 'groups' && currentMenu !== 'public_channels' && currentMenu !== 'gaiadrop' && currentMenu !== 'vault' && (
          <button
            type="button"
            className="mobile-floating-menu mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(true)}
          >
            {t('menu') || 'Menu'}
          </button>
        )}
        {mailListCollapsed && (
          <button 
            className="mail-list-expand-handle"
            onClick={() => setMailListCollapsed(false)}
            title="Liste ausklappen"
            style={{
              position: 'absolute',
              left: '0',
              top: '50%',
              transform: 'translateY(-50%)',
              width: '20px',
              height: '60px',
              background: 'var(--card-bg)',
              border: '1px solid var(--border-color)',
              borderLeft: 'none',
              borderRadius: '0 8px 8px 0',
              color: 'var(--accent-cyan)',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 100,
              fontSize: '0.8rem',
              boxShadow: '2px 0 8px rgba(0,0,0,0.2)',
              transition: 'background 0.2s, color 0.2s'
            }}
          >
            &gt;
          </button>
        )}

        {/* DASHBOARD MODE */}
        {currentMenu === 'dashboard' && (
          <DashboardPane
            rooms={rooms}
            contacts={contacts}
            chatMessages={chatMessages}
            inboxEmails={inboxEmails}
            activeIdentity={activeIdentity}
            setCurrentMenu={setCurrentMenu}
            setActiveChatContact={setActiveChatContact}
            setActiveRoom={setActiveRoom}
            setShowCreateGroupModal={setShowCreateGroupModal}
            displayGaiaID={displayGaiaID}
            deferredPrompt={deferredPrompt}
            handleInstallApp={handleInstallApp}
            t={t}
          />
        )}

        {/* CHAT MODE */}
        {currentMenu === 'chat' && (
          <ChatPane
            activeChatContact={activeChatContact}
            contactPresence={presenceMap?.[(activeChatContact?.gaiaID || '').toLowerCase()]}
            chatMessages={chatMessages}
            activeIdentity={activeIdentity}
            chatInputText={chatInputText}
            setChatInputText={setChatInputText}
            handleSendChatMessage={handleSendChatMessage}
            setActiveChatContact={setActiveChatContact}
            showEmojiPicker={showEmojiPicker}
            setShowEmojiPicker={setShowEmojiPicker}
            handleDeleteChatMessage={(msgId) => handleDeleteChatMessage(msgId, setInboxEmails, setSentEmails)}
            handleEditChatMessage={handleEditChatMessage}
            handleClearDirectChat={handleClearDirectChat}
            openContactProfile={openContactProfile}
            messageMeta={messageMeta}
            onToggleMessagePin={toggleMessagePin}
            onToggleMessageSaved={toggleMessageSaved}
            onReactToMessage={reactToMessage}
            messageReplyTarget={messageReplyTarget}
            setMessageReplyTarget={setMessageReplyTarget}
            t={t}
            displayGaiaID={displayGaiaID}
            getSenderRoles={getSenderRoles}
            unreadMarker={activeDirectUnreadMarker}
            uploadProgress={chatUploadProgress}
            uploadChatFile={uploadChatFile}
            toggleBlockContact={toggleBlockContact}
          />
        )}

        {/* GROUP CHAT */}
        {currentMenu === 'groups' && (
          <GroupChatPane
            activeRoom={activeRoom}
            channels={channels}
            activeChannel={activeChannel}
            setActiveChannel={setActiveChannel}
            chatMessages={chatMessages}
            activeIdentity={activeIdentity}
            chatInputText={chatInputText}
            setChatInputText={setChatInputText}
            handleSendGroupMessage={handleSendGroupMessage}
            handleUpdateMemberRole={handleUpdateMemberRole}
            handleLeaveRoom={handleLeaveRoom}
            setShowCreateChannelModal={setShowCreateChannelModal}
            triggerAlert={triggerAlert}
            displayGaiaID={displayGaiaID}
            t={t}
            openContactProfile={openContactProfile}
            handleOpenGroupSettings={handleOpenGroupSettings}
            handleDeleteChatMessage={(msgId) => handleDeleteChatMessage(msgId, setInboxEmails, setSentEmails)}
            handleClearGroupChannel={handleClearGroupChannel}
            setActiveRoom={setActiveRoom}
            setMobileMenuOpen={setMobileMenuOpen}
            messageMeta={messageMeta}
            onToggleMessagePin={toggleMessagePin}
            onToggleMessageSaved={toggleMessageSaved}
            onReactToMessage={reactToMessage}
            unreadMarker={activeGroupUnreadMarker}
            messageReplyTarget={messageReplyTarget}
            setMessageReplyTarget={setMessageReplyTarget}
            getSenderRoles={getSenderRoles}
            contacts={contacts}
            fetchRooms={fetchRooms}
          />
        )}

        {currentMenu === 'public_channels' && (
          <PublicChannelsPane
            activeIdentity={activeIdentity}
            activePublicChannel={activePublicChannel}
            creatorOpen={publicChannelCreatorOpen}
            setCreatorOpen={setPublicChannelCreatorOpen}
            publicChannelPosts={publicChannelPosts}
            publicChannelsError={publicChannelsError}
            publicChannelPostsLoading={publicChannelPostsLoading}
            createChannel={createPublicChannel}
            updateChannel={updatePublicChannel}
            toggleSubscription={togglePublicChannelSubscription}
            createPost={createPublicChannelPost}
            togglePostReaction={togglePublicChannelPostReaction}
            createPostComment={createPublicChannelPostComment}
            togglePostPin={togglePublicChannelPostPin}
            updateChannelComments={updatePublicChannelComments}
            reportChannel={reportChannel}
            deleteChannel={deleteChannel}
            verifyChannel={verifyChannel}
            showConfirm={showConfirm}
            triggerAlert={triggerAlert}
            setMobileMenuOpen={setMobileMenuOpen}
            contacts={contacts}
          />
        )}

        {currentMenu === 'network_health' && (
          <NetworkHealthDashboard embedded />
        )}

        {/* COMPOSER MODE */}
        {isComposing && currentMenu !== 'chat' && currentMenu !== 'profile' && currentMenu !== 'groups' && currentMenu !== 'public_channels' && currentMenu !== 'network_health' && (
          <ComposerPane
            isSmtpMode={isSmtpMode}
            setIsSmtpMode={setIsSmtpMode}
            composeTo={composeTo}
            setComposeTo={setComposeTo}
            composeSubject={composeSubject}
            setComposeSubject={setComposeSubject}
            composeBody={composeBody}
            setComposeBody={setComposeBody}
            fileInputRef={fileInputRef}
            handleFileUpload={handleFileUpload}
            uploadFile={uploadFile}
            uploadProgress={uploadProgress}
            composeError={composeError}
            handleSendMail={handleSendMail}
            setIsComposing={setIsComposing}
            contacts={contacts}
            mailSettings={mailSettings}
            isSavingDraft={isSavingDraft}
            t={t}
          />
        )}

        {/* READER MODE */}
        <ReaderPane
          selectedMail={selectedMail}
          selectedMailProof={selectedMailProof}
          activeIdentity={activeIdentity}
          contacts={contacts}
          handleReplyMail={handleReplyMail}
          handleExportDisclosurePackage={handleExportDisclosurePackage}
          handleReportMail={handleReportMail}
          setSelectedMail={setSelectedMail}
          isComposing={isComposing}
          currentMenu={currentMenu}
          openContactProfile={openContactProfile}
          t={t}
          updateMailboxState={updateMailboxState}
          snoozeMail={snoozeMail}
          labelsList={labelsList}
          saveLabel={saveLabel}
        />

        {/* PROFILE MODE */}
        {currentMenu === 'profile' && (
          <ProfilePane
            activeIdentity={activeIdentity}
            displayGaiaID={displayGaiaID}
            profileAvatar={profileAvatar}
            setProfileAvatar={setProfileAvatar}
            profileDisplayName={profileDisplayName}
            setProfileDisplayName={setProfileDisplayName}
            profileBio={profileBio}
            setProfileBio={setProfileBio}
            saveProfile={saveProfile}
            handleAvatarFileChange={handleAvatarFileChange}
            currentPasswordInput={currentPasswordInput}
            setCurrentPasswordInput={setCurrentPasswordInput}
            newPasswordInput={newPasswordInput}
            setNewPasswordInput={setNewPasswordInput}
            confirmPasswordInput={confirmPasswordInput}
            setConfirmPasswordInput={setConfirmPasswordInput}
            passwordChangeError={passwordChangeError}
            handleChangePassword={handleChangePassword}
            areKeysUnlocked={areKeysUnlocked}
            profilePasswordInput={profilePasswordInput}
            setProfilePasswordInput={setProfilePasswordInput}
            handleUnlockProfileKeys={handleUnlockProfileKeys}
            profileUnlockError={profileUnlockError}
            derivedKeys={derivedKeys}
            mnemonic={mnemonic}
            setAreKeysUnlocked={setAreKeysUnlocked}
            setCurrentMenu={setCurrentMenu}
            t={t}
            activeSection={activeProfileSection}
            setActiveProfileSection={setActiveProfileSection}
            cryptoSessionMinutes={cryptoSessionMinutes}
            setCryptoSessionMinutes={setCryptoSessionMinutes}
            inactivityLockMinutes={inactivityLockMinutes}
            setInactivityLockMinutes={setInactivityLockMinutes}
            pinUnlockEnabled={pinUnlockEnabled}
            handleSetUnlockPin={handleSetUnlockPin}
            handleRemoveUnlockPin={handleRemoveUnlockPin}
            handleDeleteAccount={handleDeleteAccount}
            handleExportRecoveryBackup={handleExportRecoveryBackup}
            user={user}
            handleUpdatePrivacySettings={handleUpdatePrivacySettings}
            mailSettings={mailSettings}
            saveSettings={saveSettings}
            filterRules={filterRules}
            saveFilterRule={saveFilterRule}
            labelsList={labelsList}
          />
        )}

        {/* VAULT MODE */}
        {currentMenu === 'vault' && (
          <VaultPane
            vaultUnlocked={vaultUnlocked}
            vaultPasswordInput={vaultPasswordInput}
            setVaultPasswordInput={setVaultPasswordInput}
            vaultError={vaultError}
            vaultRecords={vaultRecords}
            vaultDraftTitle={vaultDraftTitle}
            setVaultDraftTitle={setVaultDraftTitle}
            vaultDraftCategory={vaultDraftCategory}
            setVaultDraftCategory={setVaultDraftCategory}
            vaultDraftBody={vaultDraftBody}
            setVaultDraftBody={setVaultDraftBody}
            handleUnlockVault={handleUnlockVault}
            handleAddVaultRecord={handleAddVaultRecord}
            handleDeleteVaultRecord={handleDeleteVaultRecord}
            handleLockVault={handleLockVault}
            selectedVaultRecord={selectedVaultRecord}
            setSelectedVaultRecord={setSelectedVaultRecord}
            t={t}
            triggerAlert={triggerAlert}
            setMobileMenuOpen={setMobileMenuOpen}
          />
        )}

        {/* GAIADROP MODE */}
        {currentMenu === 'gaiadrop' && (
          <DropPane
            gaiaDropInbox={gaiaDropInbox}
            gaiaDropLoading={gaiaDropLoading}
            gaiaDropError={gaiaDropError}
            selectedDrop={selectedDrop}
            setSelectedDrop={setSelectedDrop}
            loadGaiaDropInbox={loadGaiaDropInbox}
            activeIdentity={activeIdentity}
            displayGaiaID={displayGaiaID}
            handleDeleteDrop={handleDeleteDrop}
            t={t}
            triggerAlert={triggerAlert}
            setMobileMenuOpen={setMobileMenuOpen}
          />
        )}

        {/* ABUSE CENTER */}
        {currentMenu === 'abuse_center' && (
          <AbuseCenter
            activeIdentity={activeIdentity}
            triggerAlert={triggerAlert}
            setMobileMenuOpen={setMobileMenuOpen}
            t={t}
          />
        )}

        {/* SECURITY CENTER */}
        {currentMenu === 'security_center' && (
          <SecurityCenter
            activeIdentity={activeIdentity}
            triggerAlert={triggerAlert}
            setMobileMenuOpen={setMobileMenuOpen}
            t={t}
          />
        )}
      </main>
    </>
  );
}


